// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import CasavioLogo from './shared/CasavioLogo'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', brown: '#2C1D14', muted: '#9A7B68',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

const sections = [
  {
    n: 1, title: 'AGREEMENT TO TERMS',
    body: `By accessing or using Casavio ("the Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Service.

These Terms constitute a legally binding agreement between you and Casavio, LLC ("we," "our," or "us").`,
  },
  {
    n: 2, title: 'CHANGES TO TERMS',
    body: `We reserve the right to modify these Terms at any time. We will notify you of material changes by email or by posting a notice within the app. Your continued use of the Service after changes are posted constitutes acceptance of the updated Terms.`,
  },
  {
    n: 3, title: 'DESCRIPTION OF SERVICE',
    body: `Casavio is a home management platform that helps homeowners and residents:
• Track appliances and home systems
• Schedule and log maintenance tasks
• Store home-related documents and photos
• Generate maintenance reminders
• Access AI-powered features including owner's manual lookup

The Service is provided through our web application at casavio-app.vercel.app.`,
  },
  {
    n: 4, title: 'ACCOUNT REGISTRATION',
    body: `To use Casavio, you must create an account by providing:
• Your first and last name
• A valid email address
• A secure password

You must be at least 18 years of age to create an account. By registering, you represent that all information you provide is accurate and that you will keep it up to date.`,
  },
  {
    n: 5, title: 'ACCOUNT SECURITY',
    body: `You are responsible for maintaining the confidentiality of your account credentials. You agree to:
• Use a strong, unique password for your account
• Notify us immediately at support@casavio.app if you suspect unauthorized access
• Not share your account with others

We are not liable for any loss or damage resulting from unauthorized access to your account due to your failure to keep your credentials secure.`,
  },
  {
    n: 6, title: 'SUBSCRIPTION AND FEES',
    body: `Casavio currently offers the Service during an early-access period. Pricing terms will be communicated clearly before any charges apply. We reserve the right to introduce paid tiers in the future with advance notice to existing users.

All fees, if and when introduced, are non-refundable except as required by law or as described in our cancellation policy.`,
  },
  {
    n: 7, title: 'FREE TRIAL',
    body: `We may offer a free trial period for new users. Free trial terms, including duration and feature access, will be clearly stated at the time of registration. At the end of the trial period, continued use may require a paid subscription.`,
  },
  {
    n: 8, title: 'CANCELLATION',
    body: `You may cancel your Casavio account at any time by contacting us at support@casavio.app or through your account Settings.

Upon cancellation:
• Your access to the Service will continue until the end of your current billing period
• Your data will be retained for 30 days after cancellation, during which you may request a data export
• After 30 days, your data will be permanently deleted`,
  },
  {
    n: 9, title: 'ACCEPTABLE USE',
    body: `You agree to use Casavio only for lawful purposes and in accordance with these Terms. You agree not to:
• Use the Service in any way that violates applicable laws or regulations
• Attempt to gain unauthorized access to any part of the Service or its infrastructure
• Interfere with or disrupt the integrity or performance of the Service
• Use automated tools to scrape, crawl, or extract data from the Service
• Impersonate any person or entity or misrepresent your affiliation
• Upload or transmit malicious code, viruses, or harmful content`,
  },
  {
    n: 10, title: 'USER CONTENT',
    body: `You retain ownership of all content you upload to Casavio, including documents, photos, and maintenance records ("User Content").

By uploading User Content, you grant Casavio a limited, non-exclusive license to store, process, and display your content solely for the purpose of providing the Service to you.

You are solely responsible for ensuring you have the right to upload any content and that it does not violate any third-party rights.`,
  },
  {
    n: 11, title: 'INTELLECTUAL PROPERTY',
    body: `The Service, including its design, software, features, and content (excluding User Content), is owned by Casavio, LLC and protected by copyright, trademark, and other intellectual property laws.

You may not copy, modify, distribute, sell, or lease any part of the Service without our prior written consent. The CASAVIO name and logo are trademarks of Casavio, LLC.`,
  },
  {
    n: 12, title: 'AI-POWERED FEATURES',
    body: `Casavio uses artificial intelligence technology, including Claude by Anthropic, to power features such as owner's manual lookup. When you use these features:
• Appliance make and model information is sent to Anthropic's API
• AI-generated results may not be 100% accurate
• You should verify important information independently

We are not responsible for decisions made based on AI-generated content. These features are provided as a convenience and do not substitute for professional advice.`,
  },
  {
    n: 13, title: 'THIRD-PARTY SERVICES',
    body: `Casavio integrates with third-party services including Supabase, Anthropic, Resend, and Vercel. Your use of these integrations is subject to those providers' terms and policies. We are not responsible for the availability, accuracy, or practices of third-party services.

Links to external websites or resources in the Service are provided for convenience only. We do not endorse and are not responsible for the content of third-party sites.`,
  },
  {
    n: 14, title: 'AFFILIATE LINKS AND COMMISSIONS',
    body: `Casavio is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com.

When you click on certain product links within the Service (for example, "Order Parts" or other purchase suggestions), you may be directed to Amazon.com or other third-party retailers. If you complete a purchase after clicking one of these links, Casavio may receive a commission at no additional cost to you.

This affiliate relationship does not influence which products we recommend. Recommendations are based on the appliance information you provide and the maintenance task at hand. You are under no obligation to purchase through our links and may search for and purchase parts independently.

As an Amazon Associate, Casavio earns from qualifying purchases.`,
  },
  {
    n: 15, title: 'DATA AND PRIVACY',
    body: `Your use of Casavio is also governed by our Privacy Policy, which is incorporated into these Terms by reference. By using the Service, you consent to the collection and use of your information as described in the Privacy Policy.

You may request a copy of your personal data or deletion of your account by contacting privacy@casavio.app.`,
  },
  {
    n: 16, title: 'DISCLAIMERS',
    body: `THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.

We do not warrant that:
• The Service will be uninterrupted, error-free, or secure
• Maintenance recommendations or schedules will be accurate or complete
• AI-generated content will be correct or suitable for your specific appliance or situation

Any reliance on information provided through the Service is at your own risk. Always consult qualified professionals for home repair, maintenance, or safety decisions.`,
  },
  {
    n: 17, title: 'LIMITATION OF LIABILITY',
    body: `TO THE MAXIMUM EXTENT PERMITTED BY LAW, CASAVIO, LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, OR GOODWILL.

OUR TOTAL CUMULATIVE LIABILITY TO YOU FOR ANY CLAIMS ARISING FROM OR RELATED TO THESE TERMS OR THE SERVICE SHALL NOT EXCEED THE AMOUNT YOU PAID US IN THE TWELVE MONTHS PRIOR TO THE CLAIM, OR $100 IF YOU HAVE NOT MADE ANY PAYMENTS.`,
  },
  {
    n: 18, title: 'INDEMNIFICATION',
    body: `You agree to defend, indemnify, and hold harmless Casavio, LLC and its officers, directors, employees, and agents from any claims, liabilities, damages, costs, and expenses (including reasonable attorneys' fees) arising from:
• Your use of the Service
• Your violation of these Terms
• Your violation of any third-party rights
• Your User Content`,
  },
  {
    n: 19, title: 'GOVERNING LAW',
    body: `These Terms are governed by the laws of the State of California, without regard to its conflict of law provisions.

Any disputes arising from these Terms or the Service shall be resolved through binding arbitration in Sonoma County, California, except that either party may seek injunctive or other equitable relief in any court of competent jurisdiction.

If any provision of these Terms is found unenforceable, the remaining provisions will remain in full effect.`,
  },
  {
    n: 20, title: 'CONTACT US',
    body: `If you have questions about these Terms, please contact us at:
Casavio, LLC
support@casavio.app
casavio-app.vercel.app`,
  },
]

export default function TermsOfService() {
  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: fs }}>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '48px 24px 80px' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <CasavioLogo size={26} color={C.amber} style={{ justifyContent: 'center', marginBottom: '8px' }} />
          <div style={{ fontFamily: f, fontSize: '24px', color: C.brown, marginBottom: '6px' }}>Terms of Service</div>
          <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs }}>Last Updated: May 9, 2026</div>
        </div>

        {/* Back link */}
        <div style={{ marginBottom: '32px' }}>
          <a href="/" style={{ fontSize: '13px', color: C.amber, textDecoration: 'none', fontFamily: fs }}>
            ← Back to App
          </a>
        </div>

        {/* Sections */}
        {sections.map(s => (
          <div key={s.n} style={{ marginBottom: '32px', background: C.card, borderRadius: '12px', padding: '24px', border: `1px solid ${C.border}` }}>
            <div style={{ fontFamily: f, fontSize: '15px', fontWeight: '700', color: C.amber, marginBottom: '12px', letterSpacing: '0.5px' }}>
              {s.n}. {s.title}
            </div>
            <div style={{ fontSize: '14px', color: C.brown, lineHeight: '1.8', whiteSpace: 'pre-line', fontFamily: fs }}>
              {s.body}
            </div>
          </div>
        ))}

        {/* Footer */}
        <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: '24px', textAlign: 'center' }}>
          <CasavioLogo size={14} color={C.amber} style={{ justifyContent: 'center', marginBottom: '12px' }} />
          <div style={{ display: 'flex', justifyContent: 'center', gap: '24px', flexWrap: 'wrap', marginBottom: '8px' }}>
            <a href="/privacy" style={{ fontSize: '12px', color: C.amber, textDecoration: 'none', fontFamily: fs }}>Privacy Policy</a>
            <a href="/terms" style={{ fontSize: '12px', color: C.amber, textDecoration: 'none', fontFamily: fs }}>Terms of Service</a>
            <a href="mailto:support@casavio.app" style={{ fontSize: '12px', color: C.amber, textDecoration: 'none', fontFamily: fs }}>Contact Support</a>
          </div>
          <div style={{ fontSize: '11px', color: C.muted, fontFamily: fs }}>© 2026 Casavio, LLC. All rights reserved.</div>
        </div>

      </div>
    </div>
  )
}
